import config from "config.json";
import http from "core/service/httpService";

export function fetchGuestTokenForDashboard(tokenPayload) {
    return http.post(`${config.apiEndpoint}/analytics/token`, tokenPayload);
}



